<tt-page class="col-xs-12 col-md-4 sp-0">
    <tt-card>
        <tt-button-goto ttText="create_new_create_new_p2exportproc" ttGoto="p2exportproc" [ttGotoParms]="{ p2_exportproc_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list [ttData]="itemsListExportProcedures"></tt-list>
</tt-page>
